import { render, staticRenderFns } from "./job-share-item.vue?vue&type=template&id=48791b84&scoped=true"
import script from "./job-share-item.vue?vue&type=script&lang=js"
export * from "./job-share-item.vue?vue&type=script&lang=js"
import style0 from "./job-share-item.vue?vue&type=style&index=0&id=48791b84&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48791b84",
  null
  
)

export default component.exports